import { createSelector } from 'reselect';
import { getDepositPayFilter, getIsLoading } from './propertyAvailabilitySelectors';
import { createClassicRewardsAvailabilityMessage } from 'lib/search/createClassicRewardsAvailabilityMessage';

export const getClassicRewardAvailabilityMessage = createSelector(getIsLoading, getDepositPayFilter, (isLoading, depositPayFilter) => {
  const message = createClassicRewardsAvailabilityMessage(isLoading, depositPayFilter);
  if (!message) return null;

  return message && `Classic Rewards are ${message}.`;
});
